export * from './objekt-sorter.component';
export * from './objekt-sorter.component.module';